import { DARK, DARK_BLACK_FRIDAY, DEFAULT } from './names';

export const CSS_MODIFIERS = {
  [DEFAULT]: '',
  [DARK]: '_dark-theme',
  [DARK_BLACK_FRIDAY]: '_black-friday-theme',
};
